import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  backgroundColor: colors.white,
  fontSize: '20px',
  '& #process-step-container': {
    backgroundColor: colors.white
  },
  '& #process-step-title': {
    transition: 'color 0.3s ease',
    color: colors.black,
    fontSize: '20px'
  },
  '& #process-list-item': {
    transition: 'color 0.3s ease',
    color: colors.black
  },
  '& #process-step-icon': {
    transition: 'all 0.3s ease',
    backgroundColor: colors.white,
    boxShadow: '0 0 0 8px ' + colors.white,
    color: colors.secondary
  },
  '& #process-step-description': {
    transition: 'color 0.3s ease',
    color: colors.secondary,
    
  },
  '& #social-proof-slot-description': {
    color: colors.secondary
  },
  '& .active-step': {
    '& #process-step-title': {
      color: colors.primary
    },
    '& #process-step-icon': {
      color: colors.primary,
      backgroundColor: '#fee2e2'
    },
    '&#process-list-item': {
      color: colors.primary
    },
  }
};

const templateStyles: any = (theme?: Theme) => styles;

export default templateStyles;